import { useParams } from "react-router-dom";
import Viewer from "./Viewer";

const ViewerWrapper = ({ headerHeight }) => {
  const { modelCode } = useParams();
  return <Viewer headerHeight={headerHeight} modelCode={modelCode} />;
};

export default ViewerWrapper;
